export const SET_MANAGERS_DATA = 'SET_MANAGERS_DATA';
export const SET_SHOPS_DATA = 'SET_SHOPS_DATA';